import { createContext } from "react";

// Optimistic default (everything allowed) until /me loads — the backend is the
// real enforcer; the UI only hides controls the role can't use.
export const DEFAULT_PERMS = {
  role: "",
  actions: { view: true, create: true, edit: true, delete: true, export: true, approve: true, manage_roles: true },
};

export const PermsContext = createContext(DEFAULT_PERMS);
